import { observer } from 'mobx-react-lite'
import React, { useContext, useEffect, useMemo, useState } from 'react'
import { Person, Trash, ArrowLeft } from 'react-bootstrap-icons'
import { CampaignContext } from '../../../../../../../contexts/CampaignContext'
import axiosService from '../../../../../../../utils/AxiosService'
import ReactMultiSelect from '../../../../../../FormComponents/ReactMultiSelect'
import { toastError, toastSuccess } from '../../../../../../FormComponents/Toasts'
import Modal from '../../../../../../Modal/Modal'

export default observer(function CollaboratorModal({ collaboratorModalOpen, setCollaboratorModalOpen }) {
  const { collaborators, campaign, campaignState } = useContext(CampaignContext)
  const [selectedCollaborators, setSelectedCollaborators] = useState([])

  const [projectManagers, setProjectManagers] = useState([])
  const collaboratorIds = useMemo(() => collaborators.reduce((ids, collaborator) => [...ids, collaborator.id], []), [collaborators, collaborators.length])

  const collaboratorOptions = useMemo(() => projectManagers.reduce((options, projectManager) => {
    if (!collaboratorIds.includes(projectManager.id)) options.push({ label: `${projectManager.first_name} ${projectManager.last_name}`, value: projectManager.id })
    return options
  }, []),
  [projectManagers, collaboratorIds, collaboratorIds.length])

  const getProjectManagers = () => {
    axiosService.get('/api/project_manager/project_managers')
    .then(projectManagers => {
      setProjectManagers(projectManagers)
    })
  }

  useEffect(() => getProjectManagers(), [])

  const removeCollaborator = id => () => {
    axiosService.delete(`/api/project_manager/campaigns/${campaign.id}/collaborators/${id}`)
    .then(() => {
      campaignState.collaborators = collaborators.filter(collaborator => collaborator.id !== id)
      toastSuccess('Collaborator removed')
    })
    .catch(({ data: { error } }) => toastError(error))
  }

  const addCollaboratorsToCampaign = () => {
    console.log(selectedCollaborators)
    axiosService.post(`/api/project_manager/campaigns/${campaign.id}/collaborators`, { collaborator_ids: selectedCollaborators.map(collaborator => collaborator.value) })
    .then(collaborators => {
      campaignState.collaborators = collaborators
      toastSuccess('Collaborators added')
      setSelectedCollaborators([])
    })
    .catch(({ data: { error }}) => toastError(error))
  }

  return (
    <Modal isOpen={collaboratorModalOpen} onClose={() => setCollaboratorModalOpen(false)} hasSideBar >
      <Modal.Body>
        <div className="p-2 w-[500px] overflow-y-auto  min-h-[300px] max-h-[500px]">
          <div className="flex justify-between items-center pb-4">
            <h2 className='font-bold text-2xl'>Collaborators</h2>
            <Modal.DissmissButton className='flex items-center p-2 rounded-lg hover:bg-gray-200'>
              <ArrowLeft className='mr-1 font-bold' /><span className='font-bold'>Back</span>
            </Modal.DissmissButton>
          </div>
          <div className="flex items-center">
            <div className="w-full mr-4">
              <ReactMultiSelect
                placeholder="Select Collaborators"
                name="collaborators"
                onChange={collaborators => setSelectedCollaborators(collaborators)}
                options={collaboratorOptions}
                value={selectedCollaborators}
                hasSelectAll={false}
              />
            </div>
            <div>
              <button className={`bg-rb-green text-white rounded p-2 w-40 ${!selectedCollaborators.length && 'opacity-50'}`} disabled={!selectedCollaborators.length} onClick={addCollaboratorsToCampaign}>Add to campaign</button>
            </div>
          </div>
          <p className='mt-5'>Added to the campaign</p>
          <div className='mt-2 w-full'>
            {collaborators.map(collaborator => (
              <div key={collaborator.id} className="flex justify-between border-1 border-gray-300 rounded p-2 mb-2 w-100">

                <div className='flex'>
                  <div className='mr-3'>
                    {
                      collaborator.avatar?.url ? (
                        <img title={`${collaborator.first_name} ${collaborator.last_name}`} className="w-10 h-10 rounded-md object-cover" src={collaborator.avatar?.url} alt="avatar"/>
                      ) : (
                        <div className="w-10 h-10 bg-rb-green rounded-md text-white flex items-center justify-center border-1 border-white" title={`${collaborator.first_name} ${collaborator.last_name}`}><Person /></div>
                      )
                    }
                  </div>
                  <div>
                    <p className="text-sm font-bold">{collaborator.first_name} {collaborator.last_name}</p>
                    <p className="text-sm font-normal text-gray-400">{collaborator.email}</p>
                  </div>
                </div>

                <div className="flex self-end justify-center items-center">
                  <button className="text-sm font-bold flex justify-center items-center hover:bg-gray-200 rounded-md p-2" onClick={removeCollaborator(collaborator.id)}><Trash className='mr-1'/><p>Remove</p></button>
                </div>

              </div>
            ))}
          </div>
        </div>
      </Modal.Body>
    </Modal>
  )
})
